import React, { useMemo } from 'react';
import { SideNavGroup } from '@amzn/aac-chrome-internal-api';
import { externalLinkAlt } from '@amzn/storm-ui-icons';
import {
  AccordionContentGroupWrapper,
  AccordionContentSubTitle,
  AccordionContentWrapper,
  AccordionLink,
  ExternalIcon,
  StyledDivider as Divider,
} from '../styles';
import { useConsolidatedNavContext } from 'src/providers/ConsolidatedNavContextProvider';

interface AccordionContentProps {
  id: string;
}

const AccordionContent: React.VFC<AccordionContentProps> = ({ id }) => {
  const { isNavOpen, toolbarItems } = useConsolidatedNavContext();
  const toolbarItem = useMemo(
    () => toolbarItems.find((toolbarItem) => toolbarItem.id === id),
    [toolbarItems],
  );

  if (!toolbarItem) {
    return null;
  }

  const { sidebarGroups: groups } = toolbarItem;

  // TODO: Add CSR functionality

  return (
    <AccordionContentWrapper>
      {groups.map((group: SideNavGroup, index: number) => (
        <AccordionContentGroupWrapper key={`${index}-${group.title}`}>
          {group.title && (
            <AccordionContentSubTitle>{group.title}</AccordionContentSubTitle>
          )}
          {group.links.map((link) => {
            const isExternalLink = link.sidebarItemType === 'EXTERNAL_LINK';
            return (
              <AccordionLink
                key={link.id}
                isSelected={link.isSelected ?? false}
                href={link.link.url}
                target={isExternalLink ? '_blank' : '_self'}
                data-takt-id={link.id}
                data-ccx-e2e-id={link.id}
                tabIndex={isNavOpen ? 0 : -1}
                aria-label={link.link.label}
                {...(link.isSelected && { 'aria-current': 'page' })}
              >
                {link.link.label}
                {isExternalLink && (
                  <ExternalIcon type={externalLinkAlt} size="xs" />
                )}
                {/* TODO: Add landing icon */}
              </AccordionLink>
            );
          })}
          {index !== groups.length - 1 && <Divider />}
        </AccordionContentGroupWrapper>
      ))}
    </AccordionContentWrapper>
  );
};

export default AccordionContent;
